import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AdminService } from './admin.service';
import { CoreService } from '../core/core.service';
import { Router } from '@angular/router';
import { Main } from '../core/main.service';
import { environment } from '@env/environment';

@Component({
  selector: 'cp-users',
  templateUrl: './users.component.html',
})

export class UsersComponent {

  filter: string;
  statusFilter: string;
  verificationFilter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  users: any[];
  roles: any[];
  permissions: any[];
  ekubs: any[];
  userEkub: any;
  passwordResetForm!: FormGroup;
  selectedUser: any = {};
  baseUrl: string = environment.production
    ? environment.ONLINE_BASE_URL :
    environment.LOCAL_BASE_URL;

  constructor(private api: AdminService, private router: Router, private formBuilder: FormBuilder, private mainService: Main, @Inject(Restangular) public Restangular) {
    this.filter = '&type=system_user';
    this.statusFilter = '';
    this.verificationFilter = '';
    this.itemsPerPage = 10;
    this.totalItems = 0;
    this.currentPage = 1;
    this.userEkub = {};
    this.getUserFilter();
    this.getRoleFilter();
  }

  get user() { return this.passwordResetForm.get('user'); }
  get old_password() { return this.passwordResetForm.get('old_password'); }
  get new_password() { return this.passwordResetForm.get('new_password'); }
  get confirm_password() { return this.passwordResetForm.get('confirm_password'); }

  ngOnInit() {
    this.createForm();
    this.getAllEkubs();
  }

  private createForm() {

    this.passwordResetForm = this.formBuilder.group({
      user: ['', [Validators.required,]],
      old_password: ['', [Validators.required,]],
      new_password: ['', Validators.required],
      confirm_password: ['', Validators.required],
    });

  }

  getAllEkubs() {
    debugger;
    var filter = "?status=pending";
    this.api.getAllEkubs(filter).subscribe((res: any) => {
      debugger;
      this.ekubs = res.data;
      for (let ekub of this.ekubs) {
        ekub.text = ekub.ekub_id + ' ' + ekub.category.data.title + ':' + ekub.category.data.amount + '/' + ekub.category.data.interval;
        ekub.id = ekub.id;
      }
    });
  }

  getUserFilter() {
    debugger;
    var filter = this.filter + this.statusFilter + this.verificationFilter;
    this.getUsers(filter);
  }

  getUsers(filter: any) {
    let j = this.itemsPerPage * this.currentPage - this.itemsPerPage;
    this.api.getUsers(this.currentPage, filter).subscribe((resp: any) => {
      this.users = resp.data;
      for (let i = 0; i < this.users.length; i++) {
        this.users[i].no = j + 1;
        j++;
      }
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    }, (err: any) => {
      debugger;
      this.mainService.toast({ title: 'Error', body: err.data.message, type: 'error' });
    });
  }

  changePassword() {
    debugger;
    var dto = {
      "old_password": this.old_password.value,
      "new_password": this.new_password.value,
      "confirm_password": this.confirm_password.value
    };
    this.api.changePassword(dto, this.selectedUser.id).subscribe((res: any) => {
      debugger;
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'success' });
    }, (err: any) => {
      debugger;
      //this.mainService.addToast('Error', err.statusText);
      this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
    });
  }

  setUser(user: any) {
    debugger;
    this.selectedUser = user;
  }

  changeStatus(id: any, status: any) {
    this.api.changeUserStatus(id, status).subscribe((res: any) => {
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
      this.getUserFilter();
    }, (err: any) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });
    });
  }

  changeVerificationStatus(id: any, status: number) {
    this.api.changeUserVerificationStatus(id, status).subscribe((res: any) => {
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
      this.getUserFilter();
    }, (err: any) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });
    });
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getUserFilter();
  }

  getRoleFilter() {
    debugger;
    var filter = this.filter + this.statusFilter + this.verificationFilter;
    this.getRoles(filter);
  }

  getRoles(filter: any) {
    let j = this.itemsPerPage * this.currentPage - this.itemsPerPage;
    this.api.getRoles(this.currentPage, filter).subscribe((resp: any) => {
      this.roles = resp.data;
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    }, (err: any) => {
      debugger;
      this.mainService.toast({ title: 'Error', body: err.data.message, type: 'error' });
    });
  }


}
